'use client';

import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';
import { DialogOverlay } from '../Dialog';
import styles from './Modal.module.scss';

interface ModalProps {
  label: string;
  onClose: () => void;
  /** Whether a click on the backdrop closes it. Escape always does. */
  autoClose?: boolean;
  children: ReactNode;
}

/**
 * A modal dialog over the page. It takes keyboard focus while open and hands
 * it back on close, so keys pressed while it is open belong to it, not to
 * whatever was focused underneath, such as the game canvas. Escape closes it,
 * and Tab stays inside it.
 */
export function Modal({ label, onClose, autoClose = true, children }: ModalProps): JSX.Element {
  return createPortal(
    <DialogOverlay
      label={label}
      onEscape={onClose}
      onBackdropClick={autoClose ? onClose : undefined}
      className={styles.overlay}
      dialogClassName={styles.dialog}
    >
      {children}
    </DialogOverlay>,
    document.body,
  );
}
